import React from "react";

const SvgBBiconsPomlcka = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <g data-name="Obecn\xE9 ikony">
      <path d="M156 110H44a10 10 0 010-20h112a10 10 0 010 20z" data-name="-" />
    </g>
  </svg>
);

export default SvgBBiconsPomlcka;
